import React from 'react';
import {connect} from 'react-redux';
import {BaseUsedTeams} from 'components/organisms/used-teams/components/sports/nhl';
import {calcPercentage} from 'helpers/common-helper';
import {TeamExposureInput} from 'components/organisms/used-teams/components/team-exposure-input';

class UsedTeamsComponent extends BaseUsedTeams {
    render() {
        const {lineups} = this.props;

        if (isEmpty(lineups.all())) {
            return null;
        }

        const lineupsList = lineups.all();
        const teamList = this.prepareTeams(this.groupTeamUsage(lineupsList));
        const countLineups = Object.keys(lineupsList).length;
        const usedTeams = [];

        if (countLineups > 0) {
            Object.values(teamList).map((team, index) => {
                const percentage = calcPercentage(countLineups, team.usedLineupsCount);

                usedTeams.push(
                    <tr key={index} className={this.getRowClassName(team, index)}>
                        <td>
                            <strong>{team.name}</strong>
                        </td>
                        <td className="text-blue">
                            {percentage}% ({team.usedLineupsCount})
                        </td>
                        <td>
                            <div className="percent-in">
                                <TeamExposureInput team={team.name} />
                                <span className="percent">%</span>
                            </div>
                        </td>
                    </tr>,
                );
            });
        } else {
            usedTeams.push(this.getNotFoundView());
        }

        return (
            <div className="players-used-table table-holder">
                <div className="table-scroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Team</th>
                                <th>Exp%</th>
                                <th>Exp.max</th>
                            </tr>
                        </thead>
                        <tbody>{usedTeams}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {lineups},
        playersData: {games},
        usedTeams,
    } = state;

    return {
        lineups,
        usedTeams,
        games,
    };
}

let UsedTeams = connect(mapStatesToProps)(UsedTeamsComponent);

export {UsedTeams};
